export const activate = {
  "activate": {
    "title": "Redeem Foxit PDF Editor",
    "subTitle": "Perpetual License",
    "content": "If you have purchased a license to Foxit PDF Editor for Windows, enter the entire registration key code here, then click Activate.",
    "activate": "Activate"
  },
  "activate_cn": {
    "title": "Redeem Foxit PDF Editor for Windows Subscription",
    "content": "Get Foxit PDF Editor for Windows Subscription with your Foxit PDF Editor for Windows Registration Key Code.<br/>Please input your Registration Key Code:",
    "activate": "Get Subscription"
  },
  "thanks": {
    "title": "License key successfully registered",
    "content": "You have successfully registered your formal license key. You can use Foxit PDF Editor for 1 year from your order date."
  },
  "error": {
    "PasswordMinLength": "6",
    "PasswordResetMaxLength": "16",
    "PasswordMaxLength": "30",
    "NameMaxLength": "50",
    "password": "Please enter a valid password.",
    "userName": "Please enter a valid name.",
    "InputNotBlank": "\"{input}\" cannot be blank.",
    "InputMinLimit": "{input} should contain at least {number} characters.",
    "InputMaxLimit": "{input} should contain at most {number} characters.",
    "TwoInputNotSame": "\"{second}\" must be equal to \"{first}\".",
    "unauthorized": "Your request was made with invalid credentials.",
    "2100031": "The password reset link is expired.",
    "110004": "Email not found. Please verify it and try again.",
    "112008": "You have subscribed to Foxit PDF Editor successfully! Please refresh to continue.",
    "112003": "Failed to subscribe to Foxit PDF Editor. Please try again.",
    "112010": "Failed to subscribe to Foxit PDF Editor. Please try again.",
    "112009": "Failed to subscribe to Foxit PDF Editor. Please try again.",
    "cancelSubscription": "Failed to cancel Foxit PDF Editor subscription. Please try again",
    "unknown": "Unknown error. Please try again.",
    "licenseCodeRedeem": {
      "111009": "This email address is already to subscribed Foxit PDF Editor!",
      "111010": "This license code has already been used. Please try another one.",
      "111011": "This license is invalid, or has expired. Please purchase Foxit PDF Editor and try again.",
      "111012": "This license code has been already used.",
      "111013": "Invalid registration key.",
      "111014": "You must have a license for PhantomPDF 9.0 or higher.",
      "111015": "Your license has expired.",
      "999999": "This license is invalid, or has expired. Please purchase Foxit PDF Editor and try again."
    },
    "subscription": {
      "onlyEducationMail": "You must use an .edu email address to subscribe to Foxit PDF Editor Education."
    }
  }
}